import React, { useRef, useState, useEffect } from 'react';
import Fuse from 'fuse.js';

const RadioButton = ({ by_search, me_search, setMe_search, setBy_search, keyValue, item, index, filters, handleChangeFilter, employees }) => {
    const isChecked = filters[keyValue]?.includes(item);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredEmployees, setFilteredEmployees] = useState(employees || []);
    const [showDropdown, setShowDropdown] = useState(false);
    const searchDropRef = useRef(null);

    const fuse = new Fuse(employees, {
        keys: ['username'],
        threshold: 0.4,
    });

    useEffect(() => {
        function handleClickOutside(event) {
            if (searchDropRef.current && !searchDropRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchQuery(query);
        setShowDropdown(true);

        if (query.trim() === '') {
            setFilteredEmployees(employees);
        } else {
            const results = fuse.search(query);
            setFilteredEmployees(results.map(result => result.item));
        }
    };

    const selectEmployee = (username, setter) => {
        setter(username);
        setSearchQuery(username);
        setShowDropdown(false);
    };

    const isBy_me = item === "By me";
    const isTo_me = item === "To me";


    return (
        <div className="checkbox-wrapper-4 !overflow-visible d-flex">
            <input
                type="checkbox"
                checked={isChecked}
                onChange={() => handleChangeFilter(keyValue, item)}
                id={item}
                className="inp-cbx"
            />
            <label htmlFor={item} className="cbx" style={keyValue === "assigned_to" ? { width: "95%" } : {}}>
                <span><svg></svg></span>
                <span className='text'>{item.slice(0, 12) || 'None'}{item.length > 12 && "..."}</span>
            </label>

            {keyValue === "assigned_to" && (
                <>
                    {(isBy_me || isTo_me) && (
                        <div className="relative !overflow-visible w-full" ref={searchDropRef}>
                            <input
                                type="text"
                                className="check_input"
                                placeholder={isBy_me ? "By Me" : "To Me"}
                                onChange={handleSearch}
                                value={searchQuery}
                                onFocus={() => isChecked && setShowDropdown(true)}
                                disabled={!isChecked} // Disable input when checkbox is unchecked
                                style={{
                                    backgroundColor: !isChecked ? '#f0f0f0' : 'white',
                                    cursor: !isChecked ? 'not-allowed' : 'text'
                                }}
                            />
                            {showDropdown && (
                                <div className="list absolute overflow-y-auto z-20 self-start top-[102%] right-0 bg-white max-h-[15em] w-full border border-gray-300 shadow-lg rounded-md">
                                    {filteredEmployees.length > 0 ? (
                                        filteredEmployees.map((emp, idx) => (
                                            <li key={idx} onClick={() => selectEmployee(emp.username, isBy_me ? setBy_search : setMe_search)} className="cursor-pointer p-2 hover:bg-gray-200">
                                                <label className="d-flex align-items-center" style={{ gap: '10px', cursor: 'pointer' }}>
                                                    <span className='!text-sm font-medium'>{emp.username}</span>
                                                </label>
                                            </li>
                                        ))
                                    ) : (
                                        <div className="p-2 !text-sm text-gray-500 text-center">No employees found</div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default RadioButton;
